import { Box } from "@mui/material";
import { Item } from "../../types/Item";
import { FaBuilding, FaCalendar, FaFlag, FaGlobeEurope, FaMapMarkerAlt, FaShieldAlt } from "react-icons/fa";
import { DELTA_ACCENT, TEXT_SECONDARY } from "../colors";

export const ItemCard = (props: { item: Item }) => {
  const { item } = props;

  let icon = null;

  if (item.icon === "address") {
    icon = <FaMapMarkerAlt size={20} color={DELTA_ACCENT} />;
  } else if (item.icon === "date") {
    icon = <FaCalendar size={20} color={DELTA_ACCENT} />;
  } else if (item.icon === "type") {
    icon = <FaBuilding size={20} color={DELTA_ACCENT} />;
  } else if (item.icon === "jurisdiction") {
    icon = <FaGlobeEurope size={20} color={DELTA_ACCENT} />;
  } else if (item.icon === "status") {
    icon = <FaShieldAlt size={20} color={DELTA_ACCENT} />;
  } else if (item.icon === "nationality") {
    icon = <FaFlag size={20} color={DELTA_ACCENT} />;
  }

  return (
    <Box sx={styles.container}>
      {item.icon !== undefined && <Box>{icon}</Box>}
      <Box sx={styles.innerContainer}>
        <Box style={styles.title}>{item.title}</Box>
        <Box style={styles.subtitle}>{item.subtitle}</Box>
        <Box style={styles.description}>{item.description}</Box>
      </Box>
    </Box>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "row",
    padding: "10px",
  },
  title: {
    fontSize: "13px",
    fontWeight: "600",
    color: TEXT_SECONDARY,
    textTransform: "uppercase" as const,
    letterSpacing: "0.03em",
  },
  subtitle: {
    fontSize: "16px",
    color: "#1A1A1F",
    paddingTop: "6px",
  },
  description: {
    fontSize: "14px",
    color: TEXT_SECONDARY,
  },
  innerContainer: {
    marginLeft: "10px",
  },
};
